import React from "react";
import {Link} from "react-router-dom";
import {Button} from "react-bootstrap";

interface MyAreaButtonProps {
    taskCount?: number;
}

/**
 * Rendert einen fixen Button am linken Bildschirmrand, mit dem man zu /myarea weitergeleitet wird.
 * Wird ein TaskCount übergeben, wird dieser innerhalb des Buttons dargestellt
 *
 * @param taskCount
 * @constructor
 */
const MyAreaButton: ({taskCount}: MyAreaButtonProps) => JSX.Element = ({taskCount}: MyAreaButtonProps) => {
    const displayTaskCount = () => {
        if (taskCount && taskCount > 0) {
            return (
                <span>{taskCount}<i className='fa fa-exclamation-circle'/></span>
            );
        }
        return null;
    }

    return (
        <Link to='/myarea'>
            <Button className="btn my-area-button" data-toggle="tooltip" title='Zu "Meine Einreichungen"'>
                        <span>
                            <i className='fa fa-2x fa-arrow-left'/>
                            <i className='fa fa-2x fa-list'/>
                        </span>
                <br/>
                {displayTaskCount()}
            </Button>
        </Link>
    );
}

export default MyAreaButton;
